import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import styles from '../../css/admin/MyInfo.module.css';
import { useLanguage } from '../../hooks/LanguageContext';
import useAxiosAdminFetch from '../../hooks/useAxiosAdminFetch';
import translations from '../admin/translations';
import { isApp } from '../../utils/isApp'; // [APP-FORK]

export default function MyInfo() {
  const { storeNo } = useParams();
  const { fetchData } = useAxiosAdminFetch(); // 로딩의미: api 호출 중
  const { language } = useLanguage(); // 언어 상태 가져오기
  const t = translations[language]; // Translations short-hand

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadProfile = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchData({
        method: 'GET',
        url: `${process.env.REACT_APP_API_SERVER}profile`,
      });
      const data = response?.data?.data || null;
      setProfile(data);

      // URL storeNo 바꿔치기 방지(Status.js:41-72 방식): 본인 storeNo와 다르면 안내 후 본인 상점으로 이동
      const myStoreNo = data?.storeNo;
      if (myStoreNo && storeNo && String(myStoreNo) !== String(storeNo)) {
        Swal.fire({
          icon: 'warning',
          title: t.storeMismatch || '상점 불일치',
          html:
            (t.storeMismatchMessage || '다른 상점으로 접속했습니다.').replace(
              '{id}',
              data?.adminId || ''
            ) + `<br/><br/>${t.goToStore || '해당 상점으로 이동'}`,
          confirmButtonText: t.goToStore || '해당 상점으로 이동',
        }).then(() => {
          window.location.replace(`/mobile/myinfo/${myStoreNo}`);
        });
      }
    } catch (e) {
      // 세션 만료 등은 useAxiosAdminFetch에서 처리
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, [fetchData, storeNo, t]);

  useEffect(() => {
    loadProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeNo]);

  const displayOrDash = value => {
    const text = String(value ?? '').trim();
    return text.length > 0 ? text : '-';
  };

  return (
    <div className={isApp() ? `${styles.page} ${styles.pageApp}` : styles.page}>
      <section className={styles.section}>
        <div className={styles.card}>
          <div className={styles.sectionTitle}>
            {t.myInfoTitle || '상점관리자 정보'}
          </div>
          {loading ? (
            <div className={styles.empty}>
              {t.myInfoLoading || '불러오는 중...'}
            </div>
          ) : (
            <>
              <div className={styles.row}>
                <span>{t.loginUsername || '아이디'}</span>
                <strong>{displayOrDash(profile?.adminId)}</strong>
              </div>
              <div className={styles.row}>
                <span>{t.myInfoName || '이름'}</span>
                <strong>{displayOrDash(profile?.adminName)}</strong>
              </div>
              <div className={styles.row}>
                <span>{t.myInfoMobile || '휴대폰'}</span>
                <strong>{displayOrDash(profile?.mobile)}</strong>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
